import type { GeographicCoordinates, MultiPolygon } from '@/api/main/types.gen'
import type { Polygon } from 'geojson'

function closeRing(points: Array<GeographicCoordinates>): Array<[number, number]> {
  if (points.length === 0) {
    return []
  }

  const ring: Array<[number, number]> = points.map(p => [p.longitude, p.latitude])
  const [firstLon, firstLat] = ring[0]!
  const [lastLon, lastLat] = ring[ring.length - 1]!

  if (firstLon !== lastLon || firstLat !== lastLat) {
    ring.push([firstLon, firstLat])
  }

  return ring
}

export function multiPolygonToGeoJsonPolygons(geom: MultiPolygon): Array<Polygon> {
  return geom.points.map(points => ({
    type: 'Polygon',
    coordinates: [closeRing(points)],
  }))
}
